export type AgentInputRole = "canalyst" | "other_document";

interface AgentInputFile {
  name: string;
  size: number;
}

function fileExtension(name: string): string {
  const index = name.lastIndexOf(".");
  return index >= 0 ? name.slice(index).toLowerCase() : "";
}

export function validateAgentInputFile(
  file: AgentInputFile,
  role: AgentInputRole,
): string | null {
  if (file.size <= 0) {
    return `${file.name} is empty.`;
  }
  const extension = fileExtension(file.name);
  if (role === "canalyst" && extension !== ".xlsx") {
    return "Canalyst inputs must be .xlsx workbooks.";
  }
  return null;
}
